/**
 * Pure helpers for the Add / Delete industry dialogs.
 */

import { IndustryReferenceKind } from '../../client/IvtHubClient';

/** Same rule as CreateIndustry: the code lands in URL paths, CSV exports and logs. */
export const INDUSTRY_CODE = /^[A-Za-z0-9][A-Za-z0-9_-]*$/;

const REFERENCE_LABELS: Record<string, string> = {
  [IndustryReferenceKind.ASSET]: 'Assets',
  [IndustryReferenceKind.USE_CASE]: 'Use cases',
  [IndustryReferenceKind.STORYLINE]: 'Storylines',
  [IndustryReferenceKind.MOTION]: 'Motions',
  [IndustryReferenceKind.SUB_TOPIC]: 'Sub-topics',
};

/**
 * One line per kind that still references the industry. A kind this build does not know
 * still shows, under its wire name: the service added it, and hiding it would let the
 * dialog read as "nothing left to handle".
 */
export function describeReferences(refs: Record<string, number>): { label: string; count: number }[] {
  return Object.entries(refs)
    .filter(([, count]) => count > 0)
    .map(([kind, count]) => ({ label: REFERENCE_LABELS[kind] ?? kind, count }));
}
